import React from "react";
import { Link } from "react-router-dom";
import { ListChecks, Warning } from "@phosphor-icons/react";
import { Card, Pill, Stat, aud, num } from "./ui";

export function ValidationReport({ rep }) {
  if (!rep) return null;
  const d = rep.discovered || {};
  return (
    <Card title="Historical database validation report" icon={ListChecks} testId="wi-validation-report">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="Claims discovered" value={num(d.w2_items || 0)} sub="from the Warranty 2.0 board" testId="wi-stat-discovered" />
        <Stat label="Unique claims imported" value={num(rep.claims.unique)} sub={`${num(rep.claims.w2)} Warranty 2.0 claims`} testId="wi-stat-imported" />
        <Stat label="Repair orders processed" value={`${num(rep.pdfs.extracted)} / ${num(rep.pdfs.claims_with_repair_order)}`} sub={`${num(rep.pdfs.files_readable)} of ${num(rep.pdfs.files_total)} PDFs readable`} testId="wi-stat-pdfs" />
        <Stat label="Repair lines extracted" value={num(rep.lines.total)} sub={`${rep.lines.pct_classified}% classified`} tone="green" testId="wi-stat-lines" />
        <Stat label="Repair categories" value={num(rep.categories.total)} sub={`${num(rep.categories.reliable)} with reliable benchmarks`} testId="wi-stat-categories" />
        <Stat label="Benchmark coverage" value={`${rep.coverage.pct_lines}%`} sub={`of comparable lines · ${rep.coverage.pct_claims}% of claims fully covered`} tone="green" testId="wi-stat-coverage" />
        <Stat label="Incomplete / ambiguous" value={num(rep.incomplete_or_ambiguous)} sub="records awaiting review" tone={rep.incomplete_or_ambiguous ? "amber" : "green"} testId="wi-stat-incomplete" />
        <Stat label="Duplicates identified" value={num(rep.duplicates.duplicate_claims)}
          sub="claims sharing an OTMA number with an earlier claim" tone="amber" testId="wi-stat-duplicates" />
      </div>
      <div className="grid md:grid-cols-3 gap-3 mt-3">
        <Stat label="Approved claims" value={num(rep.approved.claims)} sub={`${num(rep.approved.with_valid_amount)} with a valid amount`} />
        <Stat label="Approved value (historical)" value={aud(rep.approved.total_value)} sub="AUD inc. GST, no double counting" tone="gold" />
        <Stat label="Average approved claim" value={aud(rep.approved.average)} sub="claims with valid amounts > $0" tone="gold" />
      </div>
      {rep.flags.length > 0 && (
        <div className="mt-5">
          <div className="text-[0.62rem] uppercase tracking-[0.16em] font-bold text-neutral-500 mb-2 flex items-center gap-1.5"><Warning size={12} /> Unresolved exceptions</div>
          <div className="flex flex-wrap gap-2" data-testid="wi-validation-flags">
            {rep.flags.map((f) => (
              <Link key={f.key} to={`/admin/warranty-intel/review?flag=${f.key}`} data-testid={`wi-flag-${f.key}`}
                className="inline-flex items-center gap-2 text-xs text-neutral-300 border border-neutral-800 rounded-full pl-3 pr-1.5 py-1 hover:border-amber-500/50 transition-colors">
                {f.label} <Pill tone="amber">{f.count}</Pill>
              </Link>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
}
